import { createAction, props } from '@ngrx/store';

export const notifyQuotationFinish = createAction(
  '[NOTIFIER] Notify when quotation finished.',
  props<{ wasFinished: boolean }>()
);
